export default __webpack_public_path__ + "static/media/breakfast_16.4bcc61bf.jpg";